import $ from 'jquery';
import { debounce } from '../../utils/debounce.js';

const toggleSearchContainer = () => {
	const el = {
		header: '.elementor-location-header',
		menu: '.elementor-widget-nav-menu',
		search: {
			container: '.mi-search__container',
			icon: '.mi-searchbtn',
			input_wrapper: '.e-search-input-wrapper',
		},
	};

	let $header = $();
	let $menu = $();
	let $search_container = $();
	let $search_icon = $();
	let expanded = false;

	const init = () => {
		$(function () {
			if (!$(el.search.container).length) return;

			init_close_btn();
			bindEvents();

			$(window).on('resize', debounce(bindEvents));
		});
	};

	const isDesktop = () => window.innerWidth > 1024;

	const getMenuOffset = () => {
		const $search_btn = $('.mi-searchbtn');
		$search_btn.css('margin-left', 'auto');

		const $container = $search_btn.closest('.e-con-inner');
		const containerWidth = $container.outerWidth();
		const btnPosition = $search_btn.position().left;
		const btnWidth = $search_btn.outerWidth();

		return Math.ceil(containerWidth - btnPosition - btnWidth);
	};

	const getSearchWidth = () => {
		const $searchbtn = $(el.header)
			.find('.mi-searchbtn')
			.filter(':visible');
		const styleParent = getComputedStyle(
			$searchbtn.closest('.e-con.e-parent').get(0),
		);
		const gapCol = parseInt(styleParent.columnGap.slice(0, -2));

		return (
			$menu.find('.elementor-nav-menu').filter(':visible').width() +
			$searchbtn.width() +
			gapCol
		);
	};

	const resetToInitialState = () => {
		// Animate search container out
		$search_container.removeClass('animated');

		setTimeout(() => {
			$search_container.css({
				display: 'none',
				position: '',
				right: '',
				width: '',
			});
		}, 400);

		// Show menu on desktop
		if (isDesktop()) {
			$menu.fadeIn({
				complete: function () {
					$menu.css({
						position: '',
						right: '',
						width: '',
					});
				},
			});
		}

		expanded = false;
	};

	const init_close_btn = () => {
		const closeButtonSVG = `
			<div class="mi-search__closebtn">
				<svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M31.5 57.749c14.436 0 26.249-11.813 26.249-26.249S45.936 5.251 31.5 5.251 5.251 17.064 5.251 31.5 17.064 57.749 31.5 57.749m-7.428-18.821 14.855-14.855m.001 14.855L24.072 24.072" stroke="currentColor" stroke-width="4.725" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
		`;

		$(el.search.input_wrapper)
			.append(closeButtonSVG)
			.find('.mi-search__closebtn')
			.on('click', resetToInitialState);
	};

	const handleSearchToggle = (e) => {
		e.preventDefault();

		const currWidth = getSearchWidth();

		// Position search container on desktop
		if (isDesktop()) {
			$search_container.css({
				position: 'absolute',
				right: getMenuOffset(),
				width: currWidth,
			});
		}

		// Toggle sticky effects on mobile
		if (!isDesktop()) {
			const $sticky = $(el.header).find('.elementor-sticky');
			if (!$(el.header).find('.elementor-sticky--effects').length) {
				$sticky.toggleClass('elementor-sticky--effects');
			}
		}

		// Show search container
		$search_container.css('display', 'block').addClass('animated');

		// Hide menu on desktop
		if (isDesktop()) {
			$menu.fadeToggle({
				complete: function () {
					if (isDesktop()) {
						$menu.css({
							position: '',
							right: '',
							width: '',
						});
					}
				},
			});
		}

		expanded = !expanded;
	};

	const bindEvents = () => {
		$header = $(el.header);
		$menu = $header.find(el.menu);
		$search_container = $header.find(el.search.container);
		$search_icon = $header.find(el.search.icon);

		$search_icon.on('click', handleSearchToggle);
	};

	init();
};

try {
	toggleSearchContainer();
} catch (error) {
	console.error('Error initializing search toggle:', error);
}
